import React from "react";
import { Button, Classes, Dialog } from "@blueprintjs/core";

import { Code } from "@components/Code";
import { LOCAL_INSTALL_URL } from "@constants";
import { makeBinaryCmd, makeDockerCmd } from "@utils";

interface Props {
  id: string | undefined;
  isOpen: boolean;
  onClose: () => void;
  isDevelop: boolean;
}

export const RunLocallyDialog: React.FC<Props> = ({
  id,
  isOpen,
  onClose,
  isDevelop,
}) => (
  <Dialog isOpen={isOpen} icon="import" title="Run Locally" onClose={onClose}>
    <div className={Classes.DIALOG_BODY}>
      <div className="bp3-text-large">
        Use one of the commands below to scan your current directory:
      </div>
      <p></p>
      with a{" "}
      <a href={LOCAL_INSTALL_URL} target="_blank" rel="noopener noreferrer">
        local install
      </a>
      :
      {id ? (
        <Code copyable command>
          {makeBinaryCmd(id)}
        </Code>
      ) : (
        "loading..."
      )}
      <p></p>
      with{" "}
      <a
        href="https://hub.docker.com/r/returntocorp/semgrep"
        target="_blank"
        rel="noopener noreferrer"
      >
        docker
      </a>
      :
      {id ? (
        <Code copyable command>
          {makeDockerCmd(id, isDevelop)}
        </Code>
      ) : (
        "loading..."
      )}
    </div>
    <div className={Classes.DIALOG_FOOTER}>
      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
        <Button onClick={onClose}>Close</Button>
      </div>
    </div>
  </Dialog>
);
